module.exports = __webpack_public_path__ + "img/groups_type_login.a738c080.png";